import { FLEXIBLE_CANCELLATION_POLICY } from '~/components/Common/CustomOffers/constants';

export const isHotelItemType = (type: string | undefined): boolean => type === 'hotel';

export const isTourItemType = (type: string | undefined): boolean => type === 'tour';

export const isCruiseItemType = (type: string | undefined): boolean => type === 'cruise';

export const isTourOrCruiseItemType = (type: string | undefined): boolean =>
  isTourItemType(type) || isCruiseItemType(type);

export const isCountryRequiredItemType = (type: string | undefined): boolean =>
  isHotelItemType(type) || isTourOrCruiseItemType(type);

export const isFlightEndDateRequired = (flightType: string | undefined): boolean =>
  flightType === 'return' || flightType === 'multi-city';

export const isReasonOtherTextRequired = (reason: string | undefined): boolean => reason === 'other';

export const isVendorDepositPaymentDateRequired = (vendorDepositPaymentMade: boolean | undefined): boolean =>
  vendorDepositPaymentMade === true;

export const isVendorPaymentDateRequired = (vendorWasPaid: boolean | undefined): boolean => vendorWasPaid === true;

export const isFlexibleCancellationEndDateRequired = (cancellationType: string | null | undefined): boolean =>
  cancellationType === FLEXIBLE_CANCELLATION_POLICY;
